
import { defineComponent } from 'vue';
import AttachTrailerConfirmation from './AttachTrailerConfirmation.vue';
import CrossCompanyConfirmation from '@/views/EnterTrailer/Confirmations/CrossCompanyConfirmation.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
    name: 'EnterTrailerOverlay',
    components: {
        AttachTrailerConfirmation,
        CrossCompanyConfirmation,
    },
    emits: ['onAccept', 'onReject', 'onBackToScan'],
    props: {
        companyMismatch: Boolean,
        trailerIsAvailable: Boolean,
    },
    computed: {
        ...mapGetters({
            driver: 'getDriver',
            currentTrailer: 'selectedTrailer',
        }),
        driverCompany(): string | undefined {
            return this.driver.company;
        },
        trailerCompany(): string | undefined {
            return this.currentTrailer?.company;
        },
        trailerNumber(): string | undefined {
            return this.currentTrailer?.trailerNumber;
        },
    },
    mounted() {
        if (!this.trailerIsAvailable) {
            this.$router.push({
                name: 'TrailerUnavailable',
                query: {
                    trailerNumber: this.currentTrailer?.trailerNumber,
                    trailerCompany: this.currentTrailer?.company,
                },
            });
        }
    },
});
